import './Marketing.scss';
import Component from './Marketing.js';
export default Component;
